export default __webpack_public_path__ + "static/media/location.de35215c.svg";